class WelluviProductGallery extends HTMLElement {
  connectedCallback() {
    this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    this.panels = [...this.querySelectorAll('[data-gallery-panel]')];
    this.stage = this.querySelector('[data-gallery-stage]');
    this.index = Math.max(0, this.thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.show(Number(thumb.dataset.index)));
    });

    this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.show(this.index - 1));
    this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.index + 1));

    this.stage?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.show(this.index - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.show(this.index + 1);
      }
    });

    let startX = null;
    this.stage?.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
    });
    this.stage?.addEventListener('pointerup', (event) => {
      if (startX === null) return;
      const delta = event.clientX - startX;
      startX = null;
      if (Math.abs(delta) < 45) return;
      this.show(this.index + (delta < 0 ? 1 : -1));
    });
  }

  show(nextIndex) {
    if (!this.panels.length) return;
    const normalized = (nextIndex + this.panels.length) % this.panels.length;
    this.index = normalized;

    this.panels.forEach((panel, index) => {
      const active = index === normalized;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
      if (!active) {
        panel.querySelectorAll('video').forEach((video) => video.pause());
      }
    });

    this.thumbs.forEach((thumb, index) => {
      const active = index === normalized;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });

    this.thumbs[normalized]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }
}

if (!customElements.get('welluvi-product-gallery')) {
  customElements.define('welluvi-product-gallery', WelluviProductGallery);
}
